import { withViewModel } from '../../../../infrastructure/components/with-view-model';
import { OrderTemplateFormPresentation } from './order-template-form.presentation';
import { OrderTemplateFormVM } from './order-template-form.viewmodel';

export type OrderTemplateFormProps = {
    accountId: number;
    apiCallSuccessCallback: () => void;
};

export const OrderTemplateForm = withViewModel(OrderTemplateFormPresentation, async (props: OrderTemplateFormProps) => {
    const vm = new OrderTemplateFormVM(props.accountId, props.apiCallSuccessCallback);
    await vm.loadFormData();
    return vm;
});
